import api from './api';

const reportService = {
  // ==================== INSPECTOR REPORTS ====================

  // Get count of inspectors
  getInspectorsCount: async () => {
    try {
      const response = await api.get('/api/reports/inspectors/count');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get list of all inspectors with stats
  getInspectorsList: async () => {
    try {
      const response = await api.get('/api/reports/inspectors/list');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get performance metrics for a specific inspector
  getInspectorPerformance: async (inspectorId) => {
    try {
      const response = await api.get(`/api/reports/inspector/${inspectorId}/performance`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ==================== FORM REPORTS ====================

  // Get forms grouped by equipment type
  getFormsByEquipment: async () => {
    try {
      const response = await api.get('/api/reports/forms/by-equipment');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get forms grouped by form type (ADNOC, ENAS, etc.)
  getFormsByFormType: async () => {
    try {
      const response = await api.get('/api/reports/forms/by-form-type');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get forms grouped by status
  getFormsByStatus: async () => {
    try {
      const response = await api.get('/api/reports/forms/by-status');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get forms within date range
  getFormsByDateRange: async (fromDate, toDate) => {
    try {
      const response = await api.get('/api/reports/forms/date-range', {
        params: {
          from: fromDate,
          to: toDate
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ==================== CLIENT REPORTS ====================

  // Get list of all clients
  getClientsList: async () => {
    try {
      const response = await api.get('/api/reports/clients/list');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get detailed report for a specific client
  getClientDetails: async (clientId) => {
    try {
      const response = await api.get(`/api/reports/client/${clientId}/details`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ==================== ADDITIONAL REPORTS ====================

  // Get certificate statistics
  getCertificateStats: async () => {
    try {
      const response = await api.get('/api/reports/certificates/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get overview statistics
  getOverviewStats: async () => {
    try {
      const response = await api.get('/api/reports/overview');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get monthly trends
  getMonthlyTrends: async () => {
    try {
      const response = await api.get('/api/reports/trends/monthly');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ==================== NEW COMPREHENSIVE REPORTS ====================

  getMonthlyInspections: async (year, ndtOnly = false) => {
    try {
      const response = await api.get('/api/reports/inspections/monthly', {
        params: { year, ndt_only: ndtOnly }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getClientsServed: async (year) => {
    try {
      const response = await api.get('/api/reports/clients/served', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getInspectorUtilization: async (year) => {
    try {
      const response = await api.get('/api/reports/inspector/utilization', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getCertificatesIssued: async (year) => {
    try {
      const response = await api.get('/api/reports/certificates/issued', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getInspectorLocation: async (year) => {
    try {
      const response = await api.get('/api/reports/inspector/location', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getCertificatesOnHold: async (year) => {
    try {
      const response = await api.get('/api/reports/certificates/on-hold', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getWorkOrdersStatus: async (year) => {
    try {
      const response = await api.get('/api/reports/work-orders/status', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getTrainingMonthly: async (year) => {
    try {
      const response = await api.get('/api/reports/training/monthly', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getTrainingUtilization: async (year) => {
    try {
      const response = await api.get('/api/reports/training/utilization', { params: { year } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getPendingForms: async (inspectorId) => {
    try {
      const params = inspectorId ? { inspector_id: inspectorId } : {};
      const response = await api.get('/api/reports/pending-forms', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default reportService;
